var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopTablet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5285",
    "data-name": "Group 5285",
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.107,
    height: 59.047,
    viewBox: "0 0 164.107 59.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8986",
    "data-name": "Path 8986",
    d: "M83.185,129.446H79.311V89.266c0-2.739-2.452-4.682-5.413-4.682H9.922c-2.963,0-5.334,1.942-5.334,4.682v40.18H.633c-.362,0-.633-.031-.633.3v.565a5.973,5.973,0,0,0,5.934,5.8H77.882a6.045,6.045,0,0,0,6.016-5.8v-.565C83.9,129.415,83.547,129.446,83.185,129.446Zm-42.2-43a1.422,1.422,0,0,1,1.848,0,1.159,1.159,0,0,1,.387.855,1.172,1.172,0,0,1-.387.86,1.391,1.391,0,0,1-1.848,0,1.17,1.17,0,0,1-.387-.86A1.15,1.15,0,0,1,40.985,86.447Zm34.392,40.574H8.521V90.041H75.377Z",
    transform: "translate(0 -77.068)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tablet_1_",
    "data-name": "tablet (1)",
    transform: "translate(100.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8997",
    "data-name": "Path 8997",
    d: "M61.24,11.258a2.782,2.782,0,0,1,.471,1.547V54.137a3.079,3.079,0,0,1-3.192,2.952H5.32a3.079,3.079,0,0,1-3.192-2.952V12.8A3.079,3.079,0,0,1,5.32,9.853H43.756V7.884H40.432V1A1.026,1.026,0,0,0,39.368.012h-14.9A1.026,1.026,0,0,0,23.408,1V7.884H5.32A5.138,5.138,0,0,0,0,12.8V54.137a5.138,5.138,0,0,0,5.32,4.92h53.2a5.138,5.138,0,0,0,5.32-4.92V12.8a4.64,4.64,0,0,0-.79-2.58ZM25.536,1.98H38.3v5.9H25.536Zm0,0",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8998",
    "data-name": "Path 8998",
    d: "M66.6,117.916H63.408V113.98H71.92v-1.968H44.256a3.948,3.948,0,1,0,0,7.873H66.6Zm-15.96,0H44.256a1.974,1.974,0,1,1,0-3.936H50.64Zm10.64,0H52.768V113.98H61.28Zm0,0",
    transform: "translate(-34.68 -98.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8999",
    "data-name": "Path 8999",
    d: "M391.448,123.094a3.813,3.813,0,0,0-1.418-2.934l-1.419,1.467a1.869,1.869,0,0,1,.568,2.169,2.131,2.131,0,0,1-1.987,1.266H384v1.968h3.192A4.106,4.106,0,0,0,391.448,123.094Zm0,0",
    transform: "translate(-332.929 -105.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9000",
    "data-name": "Path 9000",
    d: "M64,408.012h2.128v1.968H64Zm0,0",
    transform: "translate(-55.488 -357.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9001",
    "data-name": "Path 9001",
    d: "M64,360.012h2.128v1.968H64Zm0,0",
    transform: "translate(-55.488 -315.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9002",
    "data-name": "Path 9002",
    d: "M64,312.012h2.128v1.968H64Zm0,0",
    transform: "translate(-55.488 -273.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9003",
    "data-name": "Path 9003",
    d: "M112,408.012h2.128v1.968H112Zm0,0",
    transform: "translate(-97.104 -357.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9004",
    "data-name": "Path 9004",
    d: "M112,360.012h2.128v1.968H112Zm0,0",
    transform: "translate(-97.104 -315.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9005",
    "data-name": "Path 9005",
    d: "M112,312.012h2.128v1.968H112Zm0,0",
    transform: "translate(-97.104 -273.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9006",
    "data-name": "Path 9006",
    d: "M160,408.012h2.128v1.968H160Zm0,0",
    transform: "translate(-138.72 -357.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9007",
    "data-name": "Path 9007",
    d: "M160,360.012h2.128v1.968H160Zm0,0",
    transform: "translate(-138.72 -315.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9008",
    "data-name": "Path 9008",
    d: "M208,408.012h2.128v1.968H208Zm0,0",
    transform: "translate(-180.336 -357.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9009",
    "data-name": "Path 9009",
    d: "M208,360.012h2.128v1.968H208Zm0,0",
    transform: "translate(-180.336 -315.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9010",
    "data-name": "Path 9010",
    d: "M256,408.012h2.128v1.968H256Zm0,0",
    transform: "translate(-221.952 -357.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9011",
    "data-name": "Path 9011",
    d: "M256,360.012h2.128v1.968H256Zm0,0",
    transform: "translate(-221.952 -315.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9012",
    "data-name": "Path 9012",
    d: "M256,312.012h2.128v1.968H256Zm0,0",
    transform: "translate(-221.952 -273.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9013",
    "data-name": "Path 9013",
    d: "M304,408.012h2.128v1.968H304Zm0,0",
    transform: "translate(-263.569 -357.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9014",
    "data-name": "Path 9014",
    d: "M304,360.012h2.128v1.968H304Zm0,0",
    transform: "translate(-263.569 -315.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9015",
    "data-name": "Path 9015",
    d: "M304,312.012h2.128v1.968H304Zm0,0",
    transform: "translate(-263.569 -273.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9016",
    "data-name": "Path 9016",
    d: "M352,408.012h2.128v1.968H352Zm0,0",
    transform: "translate(-305.185 -357.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9017",
    "data-name": "Path 9017",
    d: "M352,360.012h2.128v1.968H352Zm0,0",
    transform: "translate(-305.185 -315.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9018",
    "data-name": "Path 9018",
    d: "M352,312.012h2.128v1.968H352Zm0,0",
    transform: "translate(-305.185 -273.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9019",
    "data-name": "Path 9019",
    d: "M400,408.012h2.128v1.968H400Zm0,0",
    transform: "translate(-346.801 -357.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9020",
    "data-name": "Path 9020",
    d: "M400,360.012h2.128v1.968H400Zm0,0",
    transform: "translate(-346.801 -315.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9021",
    "data-name": "Path 9021",
    d: "M400,312.012h2.128v1.968H400Zm0,0",
    transform: "translate(-346.801 -273.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9022",
    "data-name": "Path 9022",
    d: "M64,264.012h2.128v1.968H64Zm0,0",
    transform: "translate(-55.488 -231.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9023",
    "data-name": "Path 9023",
    d: "M112,264.012h2.128v1.968H112Zm0,0",
    transform: "translate(-97.104 -231.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9024",
    "data-name": "Path 9024",
    d: "M304,264.012h2.128v1.968H304Zm0,0",
    transform: "translate(-263.569 -231.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9025",
    "data-name": "Path 9025",
    d: "M352,264.012h2.128v1.968H352Zm0,0",
    transform: "translate(-305.185 -231.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9026",
    "data-name": "Path 9026",
    d: "M400,264.012h2.128v1.968H400Zm0,0",
    transform: "translate(-346.801 -231.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9027",
    "data-name": "Path 9027",
    d: "M64,216.012h2.128v1.968H64Zm0,0",
    transform: "translate(-55.488 -189.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9028",
    "data-name": "Path 9028",
    d: "M112,216.012h2.128v1.968H112Zm0,0",
    transform: "translate(-97.104 -189.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9029",
    "data-name": "Path 9029",
    d: "M160,216.012h2.128v1.968H160Zm0,0",
    transform: "translate(-138.72 -189.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9030",
    "data-name": "Path 9030",
    d: "M352,216.012h2.128v1.968H352Zm0,0",
    transform: "translate(-305.185 -189.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9031",
    "data-name": "Path 9031",
    d: "M400,216.012h2.128v1.968H400Zm0,0",
    transform: "translate(-346.801 -189.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9032",
    "data-name": "Path 9032",
    d: "M160.312,32.764a.948.948,0,0,0-.312.7v4.92a1.026,1.026,0,0,0,1.064.984,1.06,1.06,0,0,0,.175-.014l6.384-.984a1.1,1.1,0,0,0,.579-.275L201.158,7.561a4.2,4.2,0,0,0,0-6.263,5.068,5.068,0,0,0-6.773,0Zm10-6.414.752.7-4.513,4.175-.752-.7ZM199.653,2.69a2.331,2.331,0,0,1,0,3.479L166.937,36.478l-4.809.741V33.873l2.14-1.976,1.529,1.415a1.125,1.125,0,0,0,1.5,0l6.019-5.567a.933.933,0,0,0,0-1.392L171.8,24.944,195.89,2.69A2.888,2.888,0,0,1,199.653,2.69Zm0,0",
    transform: "translate(-138.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9033",
    "data-name": "Path 9033",
    d: "M208,32.012h2.128V33.98H208Zm0,0",
    transform: "translate(-180.336 -28.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9034",
    "data-name": "Path 9034",
    d: "M240,32.012h4.256V33.98H240Zm0,0",
    transform: "translate(-208.08 -28.074)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopTablet);
export default __webpack_public_path__ + "static/media/laptop-tablet.b2a0ee1fc77cf545c123bc2b6aed494d.svg";
export { ForwardRef as ReactComponent };